<template>
	<div class="d-flex">
		<div>
			<avatar />
		</div>
		<content-editable-input v-model="content"
								:key="contentKey"
								emojis
								:placeholder="placeholder"
								@enterPress="submit" 
								class="d-flex flex-grow-1 mx-3"/>
		<div>
			<v-btn depressed color="primary" class="h-100" @click="submit" :loading="saving">
				{{ $vuetify.lang.t('$vuetify.views.wall.post.publish') }}
			</v-btn>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import ContentEditableInput from "@/components/items/ContentEditableInput";
export default {
	name: "PostCommentAdd",
	props: {
		placeholder: {
			type: String
		},
		post: {
			type: Object,
			required: true
		}
	},
	components: {
		Avatar,
		ContentEditableInput
	},
	data () {
		return {
			contentKey: 0,
			content: {
				content: '',
				mentions: []
			},
			focused: false,
			idea: '',
			saving: false
		}
	},
	computed: {
		dark: function () {
			return this.$vuetify.theme.dark
		},
		finalModel() {
			return {
				content: this.content.content,
				mention_user_ids: this.content.mentions
			}
		}
	},
	methods: {
		async submit() {
			if(this.content.content) {
				this.saving = true;
				await this.$axios.post(`posts/problem/${this.post.id}/idea`, this.finalModel)
					.then(response => {
						this.$emit('added', response.data.data);
						this.content = {
							content: '',
							mention_users: []
						};
						this.contentKey++
					})
					.catch(error => {
						console.log("ERROR", error.response)
					})
				this.saving = false;
			}
			// api/posts/problem/{post}/idea
			console.log("SUBMIT")
		},
		addComment() {
			alert('dodaję komentarz')
		},
	},
}
</script>
